export default __webpack_public_path__ + "img/How-To-Create-A-Digital-Twin.8739a222.png";